<template>

  <v-stepper v-model="e1">

    <v-stepper-header>
      <v-stepper-step :complete="e1 >= 1" step="1">
        {{ $t("corsi.corsi") }}
      </v-stepper-step>

      <v-divider></v-divider>

     <!-- <v-stepper-step :complete="e1 > 2" step="2">
        {{ $t("corsi.seminari") }}
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3"> {{ $t("corsi.letture") }} </v-stepper-step>-->
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-row>
          <v-col class="col-lg-8 col-md-8 col-sm-12">
            <tabella-corsi tabella="corsi" class="pa-1"></tabella-corsi>
          </v-col>
          <v-col class="col-lg-4 col-md-4 col-sm-12">
            <v-row>
              <v-col cols="12" v-if="limiteCorsi.corsi.min > 0">
                <v-card >
                 
                  <v-card-text>
                  <v-progress-linear
                    v-model="percentCorsiMin"
                    height="40"
                    color="green"
                    background-color="amber"
                    
                  >
                    <strong 
                    class="font-weight-bold"
                    v-if="percentCorsiMin < 100"
                      >
                      {{ $tc("corsi.minCorsi",limiteCorsi.corsi.min - TotCorsi,{corsi:limiteCorsi.corsi.min - TotCorsi }) }}
                     
                    </strong
                    >
                    <strong 
                    class="font-weight-bold text-white"
                    v-else
                      >{{ $t("corsi.minCorsiOK") }}</strong
                    >
                  </v-progress-linear>
                  <!-- <br />
                  <v-progress-linear color="blue-grey" reverse v-model="percentCorsiMax" height="25" v-if="limiteCorsi.corsi.max!=999">
                    <strong v-if="percentCorsiMax<100">Puoi scegliere ancora n.{{limiteCorsi.corsi.max-TotCorsi}} corsi.</strong>
                    <strong v-else>Hai raggiunto il numero massimo di corsi selezionabili!</strong>

                  </v-progress-linear>-->
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <corsi-selezionati
                  tabella="corsi"
                  class="pa-1"
                ></corsi-selezionati>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <br />
        <v-btn color="primary darken-1 float-right" @click="validazione"
          >{{ $t("conferma") }}
        </v-btn>
        <!--<v-btn color="primary darken-1 float-right" @click="e1 = 2">
          {{ $t("avanti") }} <v-icon right dark> navigate_next </v-icon></v-btn
        >-->
      </v-stepper-content>

      <!--<v-stepper-content step="2">
        
        <v-row v-if="!parametriGlobali.statoSeminariLetture">
          <div class="row">
        <div class="col-sm-12">
          <v-alert
      border="bottom"
      colored-border
      type="warning"
      elevation="2"
    >
      <center><i class="material-icons">announcement</i><br>

<b>{{ $t("corsi.seminariLettureChiuse") }}</b>
    </center></v-alert>
        </div>
  </div>
        </v-row>
        
        <v-row v-else>
          <v-col class="col-lg-8 col-md-8 col-sm-12">
            <tabella-corsi tabella="seminari" class="pa-1"></tabella-corsi>
          </v-col>
          <v-col class="col-lg-4 col-md-4 col-sm-12">
           
            <v-alert v-if="iscrizione.dati.spec_scelta.CODICENU==230020"
      border="right"
      colored-border
      type="error"
      elevation="2"
    >
    <b>{{ $t("corsi.avvisoDogmatica") }} </b></v-alert>
            <v-row>
             
              <v-col cols="12" v-if="limiteCorsi.seminari.min > 0">
                <v-card >
                 
                  <v-card-text>
                  
                  <v-progress-linear
                    v-model="percentSeminariMin"
                    height="40"
                    color="green"
                    background-color="amber"
                    
                    
                  >
                    <strong v-if="percentSeminariMin < 100"
                      >
                      {{ $t("corsi.minSeminari",{corsi:limiteCorsi.seminari.min - TotSeminari }) }}
                      
                     </strong
                    >
                    <strong v-else
                      >{{ $t("corsi.minSeminariOK") }}</strong
                    >
                  </v-progress-linear>
                  <br />
                  <v-progress-linear color="blue-grey" reverse v-model="percentCorsiMax" height="25" v-if="limiteCorsi.corsi.max!=999">
                    <strong v-if="percentCorsiMax<100">Puoi scegliere ancora n.{{limiteCorsi.corsi.max-TotCorsi}} corsi.</strong>
                    <strong v-else>Hai raggiunto il numero massimo di corsi selezionabili!</strong>

                  </v-progress-linear>
                  </v-card-text></v-card>
              </v-col>
              <v-col cols="12">
                <corsiSelezionatiOrdinati
                  tabella="seminari"
                  class="pa-1"
                ></corsiSelezionatiOrdinati> </v-col
            ></v-row>
          </v-col>
        </v-row>

        <v-btn color="primary darken-1 float-left" @click="e1 = 1">
          {{ $t("indietro") }}
        </v-btn>
        <v-btn color="primary darken-1 float-right" @click="e1 = 3">
          {{ $t("avanti") }} <v-icon right dark> navigate_next </v-icon></v-btn
        >
      </v-stepper-content>

      <v-stepper-content step="3">
         <v-row v-if="!parametriGlobali.statoSeminariLetture">
          <div class="row">
        <div class="col-sm-12">
          <v-alert
      border="bottom"
      colored-border
      type="warning"
      elevation="2"
    >
      <center><i class="material-icons">announcement</i><br>

<b>{{ $t("corsi.seminariLettureChiuse") }}</b>
    </center></v-alert>
        </div>
  </div>
        </v-row>
        <v-row v-else>
          <v-col class="col-lg-8 col-md-8 col-sm-12">
            <tabella-corsi tabella="letture" class="pa-1"></tabella-corsi>
          </v-col>
          <v-col class="col-lg-4 col-md-4 col-sm-12">
            <v-row>
              <v-col cols="12" v-if="limiteCorsi.letture.min > 0">
                 <v-card >
                 
                  <v-card-text>
                  <v-progress-linear
                    v-model="percentLettureMin"
                    height="40"
                    color="green"
                    background-color="amber"
                    
                  >
                    <strong v-if="percentLettureMin < 100"
                      >
                     {{ $t("corsi.minLetture",{corsi:limiteCorsi.letture.min - TotLetture }) }}

                      
                  </strong
                    >
                    <strong v-else
                      >{{ $t("corsi.minLettureOK") }}</strong
                    >
                  </v-progress-linear>
                   <br />
                  <v-progress-linear color="blue-grey" reverse v-model="percentCorsiMax" height="25" v-if="limiteCorsi.corsi.max!=999">
                    <strong v-if="percentCorsiMax<100">Puoi scegliere ancora n.{{limiteCorsi.corsi.max-TotCorsi}} corsi.</strong>
                    <strong v-else>Hai raggiunto il numero massimo di corsi selezionabili!</strong>

                  </v-progress-linear>
                  </v-card-text></v-card>
              </v-col>
              <v-col cols="12">
                <corsiSelezionatiOrdinati
                  tabella="letture"
                  class="pa-1"
                ></corsiSelezionatiOrdinati> </v-col
            ></v-row>
          </v-col>
        </v-row>

        <v-btn color="primary darken-1 float-left" @click="e1 = 2">
          {{ $t("indietro") }}
        </v-btn>
        <v-btn color="primary darken-1 float-right" @click="validazione"
          >{{ $t("conferma") }}
        </v-btn>
      </v-stepper-content>-->
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import tabellaCorsi from "@/components/sceltacorsi/corsi.vue";
import corsiSelezionati from "@/components/sceltacorsi/corsiselezionati.vue";
//import corsiSelezionatiOrdinati from "@/components/sceltacorsi/corsiselezionatiOrdinati.vue";
export default {
  components: { tabellaCorsi, corsiSelezionati },
  data() {
    return {
      e1: 1,
    };
  },
  methods: {
    validazione() {
      this.$emit("validazione");
    },
    goStep(step)
    {this.e1= step}
  },
  activated() {
    this.e1 = 1;
  },
  computed: {
    iscrizione: {
      get: function() {
        return this.$store.state.iscrizione;
      },
    },
    limiteCorsi() {
      return this.$store.state.corsiscelti.limiti;
    },
    TotCorsi() {
      return this.$store.getters.totaleCorsiScelti;
    },
    TotSeminari() {
      return this.$store.getters.totaleSeminariScelti;
    },
    TotLetture() {
      return this.$store.getters.totaleLettureScelti;
    },
    percentCorsiMin() {
      let perc = (this.TotCorsi / this.limiteCorsi.corsi.min) * 100;
      return perc;
    },
    percentCorsiMax() {
      let perc = (this.TotCorsi / this.limiteCorsi.corsi.max) * 100;
      return perc;
    },
    percentSeminariMin() {
      let perc = (this.TotSeminari / this.limiteCorsi.seminari.min) * 100;
      return perc;
    },
    percentLettureMin() {
      let perc = (this.TotLetture / this.limiteCorsi.letture.min) * 100;
      return perc;
    },
     parametriGlobali() {
      return this.$store.state.parametri;
    },
  },
};
</script>
